//Main
import vuex from "vuex"
import vue from "vue"
import vapi from "vuex-rest-api"
import store from "./index.js"
vue.use(vuex);

//store
const persona = new vapi({
    baseURL: `${process.env.VUE_APP_REST}/api`,
    state: {
        Apersonagerente: null,
        Apersonaaprobador: null,
        Apersona:null,
        ApersonaSoporte:null,
        ATipodocumentos:null
    }
}).get({
    action: "get_personagerente",  
    path: function (obj) {      
        return `/persona/${obj.IDPersona}`},  
    onSuccess: (state, payload ) => {
        state.Apersonagerente = payload.data;      
        
    }
}).get({
    action: "get_personaaprobador",  
    path: function (obj) {      
        return `/persona/${obj.IDPersona}`},  
    onSuccess: (state, payload ) => {
        state.Apersonaaprobador = payload.data;       
    }
}).get({
    action: "get_lista",  
    path: function () {      
        return `persona/lista`},  
    onSuccess: (state, payload ) => {
        state.Apersona = payload.data;   
    }
}).get({
    action: "get_listapersonausuario",  
    path: function () {      
        return `persona/listapersonasusuario`},  
    onSuccess: (state, payload ) => {
        state.Apersona = payload.data;   
    }
}).get({
    action: "get_listapersonausuariobyid",  
    path: function (obj) {      
        return `persona/listapersonasusuario/${obj.idpersona}`},  
    onSuccess: (state, payload ) => {
        state.ApersonaSoporte = payload.data;   
    }
}).get({
    action: "get_tipodocumentos",  
    path: function () {      
        return `persona/tipodocumentos`},  
    onSuccess: (state, payload ) => {
        state.ATipodocumentos = payload.data;   
    }
}).put({
    action: "get_desbloquearusuario",  
    path: function (obj) {      
        return `usuario/desbloquear/${obj.idusuario}`},  
    onSuccess: (state, payload ) => {
        let personafound = state.Apersona.find(X => X.idusuario == payload.data.idGenerado )
        personafound.usuariobloqueado = false;
    }
}).put({
    action: "PutPersona", 
    path: function () {
        return `/persona/putpersonausuario`
    },
    onSuccess: (state, payload) => {
        store.dispatch("mensaje/set_success", payload);
    },
    onError: (state, error) => {
        error.idGenerado = -1;
        store.dispatch("mensaje/set_error", error);
    }
}).getStore();

persona.getters = {
    gpersonagerente: state => {
        return state.Apersonagerente;
    },
    gpersonaaprobador: state => {
        return state.Apersonaaprobador;
    },
    gpersonas: state => {
        return state.Apersona;
    },
    gpersonasbyid: state => {
        return state.ApersonaSoporte;
    },
    gpersonassoporte: state => {
        return state.Apersona;
    },
    gtipodocumentos: state => {
        return state.ATipodocumentos;
    }
}

export default persona;